import React from 'react';

import { ReactComponent as CloseIcon } from '../../../../../assets/icons/v3/close.svg';
import { CHALLENGES_STATUS } from '../../../../constants/challenges';
import { ITableDetailsHero } from '../../../../interfaces/tables';
import BdsLabelPill from '../../BdsLabelPill/BdsLabelPill';
import BdsSegment from '../../BdsSegment/BdsSegment';
import BdsTooltip from '../../BdsTooltip/BdsTooltip';

import './TableDetailsHero.scss';

const TableDetailsHero = ({
  open,
  icon,
  title,
  description,
  shrinkDescription,
  statusLabel,
  status,
  dateLabel,
  planLabel,
  segmentItems,
  segmentActiveIndex,
  segmentAction,
  onClose
}: ITableDetailsHero) => {
  const showSegment = segmentItems && segmentAction && segmentActiveIndex != undefined;

  return (
    <div className="table-details-hero-container">
      <CloseIcon
        className="table-details-hero-icon-close"
        onClick={onClose}
        aria-hidden={!open}
        aria-label="Close table detail hero"
      />
      <div className="middle-columns">
        <div className="circle-indicator">{icon}</div>
        <div className="right-column">
          <div className="table-details-hero-title">{title}</div>
          {description && (
            <div className={`table-details-hero-description ${shrinkDescription ? 'shrink' : ''}`}>{description}</div>
          )}
          <div className="table-details-hero-final-row">
            {status && (
              <BdsLabelPill
                text={statusLabel.toUpperCase()}
                variant={CHALLENGES_STATUS[status ?? 'success'].tagVariant}
                iconLeft={CHALLENGES_STATUS[status ?? 'success'].icon}
              />
            )}
            <div className="table-details-hero-labels">
              {planLabel && (
                <BdsTooltip message={planLabel} position="bottom-center">
                  <div className="table-details-hero-plan">{planLabel}</div>
                </BdsTooltip>
              )}
              {planLabel && <div className="table-details-hero-plan">{'  • '}</div>}
              {dateLabel && <div className="table-details-hero-date">{dateLabel}</div>}
            </div>
          </div>
        </div>
      </div>
      {showSegment && (
        <div className="table-details-hero-segment">
          <BdsSegment items={segmentItems} action={segmentAction} activeIndex={segmentActiveIndex} />
        </div>
      )}
    </div>
  );
};

export default TableDetailsHero;
